import React from 'react';
import { Link } from 'react-router-dom';
import {
  formatApprovedQuoteDate,
  type ApprovedQuoteBannerMeta,
} from '../../utils/approvedQuoteBanner';

const ApprovedQuoteBanner: React.FC<{
  meta: ApprovedQuoteBannerMeta;
  onSendApprovalEmail?: () => void;
  onEditPaymentTerms?: () => void;
  /** Approved quote with no submission-keyed bill (multi-quote CNC). */
  noBillYet?: boolean;
}> = ({ meta, onSendApprovalEmail, onEditPaymentTerms, noBillYet }) => {
  const approved = formatApprovedQuoteDate(meta.approvedAt);
  const payment = formatApprovedQuoteDate(meta.paidAt);
  return (
    <div className="srfq-timber-quote-row-banner srfq-timber-quote-row-banner--approved">
      <span className="srfq-approved-banner-title">Approved quote</span>
      {(approved || meta.initials || payment) && (
        <span className="srfq-approved-banner-meta">
          {approved && <span>Approved {approved}</span>}
          {meta.initials && <span>{meta.initials}</span>}
          {payment &&
            (meta.paymentHref ? (
              <Link
                className="srfq-approved-banner-payment"
                to={meta.paymentHref}
                title="Open this bill on Billing & Payables"
              >
                Paid {payment}
              </Link>
            ) : (
              <span>Paid {payment}</span>
            ))}
        </span>
      )}
      {noBillYet && (
        <span className="srfq-approved-banner-meta">No bill yet</span>
      )}
      {(onSendApprovalEmail || onEditPaymentTerms) && (
        <span className="srfq-approved-banner-actions">
          {onSendApprovalEmail && (
            <button
              type="button"
              className="srfq-approved-banner-terms-btn"
              onClick={onSendApprovalEmail}
            >
              Email supplier
            </button>
          )}
          {onEditPaymentTerms && (
            <button
              type="button"
              className="srfq-approved-banner-terms-btn"
              onClick={onEditPaymentTerms}
            >
              {noBillYet ? 'No bill yet, create' : 'Edit terms'}
            </button>
          )}
        </span>
      )}
    </div>
  );
};

export default ApprovedQuoteBanner;
